import React from 'react';
import $ from 'jquery';
export default class Modal extends React.Component {
  constructor() {
    super();
    this.state = {
      show: false
    }
  }
  componentDidMount() {
    let _this = this;
    $(document).on("click", function (event) {
      if (event.target === document.querySelector(".modal.modal-show")) {
        _this.setState({
          show: false
        })
      }
    });
  } 
  close(e) {
    this.setState({ show: false });
  }
  render() {
    let classShow = this.state.show ? this.props.className + " modal show" : this.props.className + " modal";
    if (this.state.show) {
      $("#" + this.props.id).show();
      $("body").addClass("modal-open");
    } else {
      $("#" + this.props.id).hide();
      $("body").removeClass("modal-open");
    }
    return (
      <div id={this.props.id} className={classShow}>
        <div className="modal-dialog modal-md" >
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title section-header" id="userDetailsModalLabel">{this.props.title}</h5>
              <span className="close" onClick={this.close.bind(this)}>
                <span aria-hidden="true">&times;</span>
              </span>
            </div>
            {
              this.props.body
            }
            {
              this.props.footer
            }
          </div>
        </div>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/modal/index.js